import { render, staticRenderFns } from "./ItemFilial.vue?vue&type=template&id=33e2857e&scoped=true"
import script from "./ItemFilial.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemFilial.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ItemFilial.vue?vue&type=style&index=0&id=33e2857e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e2857e",
  null
  
)

export default component.exports